//import Vue from 'vue'
//import Multiselect from "vue-multiselect"
import 'vue-multiselect/dist/vue-multiselect.min.css'


// register globally
//Vue.component('multiselect', Multiselect)